import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';
import { BodyPrimary } from '@liveauctioneers/hammer-ui-core/text';
import * as React from 'react';
import styled from 'styled-components';

import FormattedCurrency from '@/components/Formatted/FormattedCurrency';
import { useAppSelector } from '@/redux/hooks';
import {
    getItemSummaryCurrency,
    getItemSummaryHighBidEstimate,
    getItemSummaryLowBidEstimate,
} from '@/redux/modules/item/summary/itemSummary.selectors';

type Props = {
    className?: string;
    itemId: number;
};

const Estimate = ({ className, itemId }: Props) => {
    const currency = useAppSelector((state) => getItemSummaryCurrency(state, itemId));
    const highBidEstimate = useAppSelector((state) => getItemSummaryHighBidEstimate(state, itemId));
    const lowBidEstimate = useAppSelector((state) => getItemSummaryLowBidEstimate(state, itemId));

    if (!lowBidEstimate && !highBidEstimate) {
        return (
            <StyledEstimate
                aria-label="price range estimate"
                className={className}
                color="secondary"
            >
                <FormattedMessage
                    id="bidding_console.console.description.single_estimate"
                    values={{ number: '—' }}
                />
            </StyledEstimate>
        );
    }

    if (!lowBidEstimate || !highBidEstimate) {
        return (
            <StyledEstimate
                aria-label="price range estimate"
                className={className}
                color="secondary"
            >
                <FormattedMessage
                    id="bidding_console.console.description.single_estimate"
                    values={{
                        number: (
                            <FormattedCurrency
                                key="estimate-single-number"
                                noFraction
                                sourceCurrency={currency}
                                value={lowBidEstimate || highBidEstimate}
                            />
                        ),
                    }}
                />
            </StyledEstimate>
        );
    }

    return (
        <StyledEstimate
            aria-label="price range estimate"
            className={className}
            color="secondary"
        >
            <FormattedMessage
                id="bidding_console.console.description.estimate_range"
                values={{
                    high: (
                        <FormattedCurrency
                            key="estimate-range-high"
                            noFraction
                            sourceCurrency={currency}
                            value={highBidEstimate}
                        />
                    ),
                    low: (
                        <FormattedCurrency
                            key="estimate-range-low"
                            noFraction
                            sourceCurrency={currency}
                            value={lowBidEstimate}
                        />
                    ),
                }}
            />
        </StyledEstimate>
    );
};

export default Estimate;

const StyledEstimate = styled(BodyPrimary)`
    display: inline;
`;
